import React, { useState } from "react";
import styles from "./SubmitWithDrawalRequest.module.scss";
import GenericInput from "../../common/GenericInput";
import GenericButton from "../../common/genericButton";
import DropDown from "../../common/Dropdown/DropDown";

export default function SubmitWithDrawalRequest({ handleClick }) {
  const [selected, setSelected] = useState("Bank Country");
  const options = [];
  const changeHandler = () => {};
  return (
    <>
      <GenericInput
        label={"Account Title"}
        placeholder="Account Title"
        type="text"
        withRightIcon={false}
        name="email"
        onChange={changeHandler}
      />
      <GenericInput
        label={"Bank Account Number"}
        placeholder="Account Number"
        type="text"
        withRightIcon={false}
        name="email"
        onChange={changeHandler}
      />
      <div className={styles.label}>Select Bank Country</div>
      <DropDown selected={selected} setSelected={setSelected} options={options} showRightIcon={false}/>
      <GenericInput 
        label={"Bank Name"}
        placeholder="Bank Name"
        type="text"
        withRightIcon={false}
        name="email"
        onChange={changeHandler}
      />
      <div className={styles.buttonRow}>
        <GenericButton title={"Cancel"} onClick={handleClick} />
        <GenericButton title={"Submit Request"} />
      </div>
    </>
  );
}
